import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const cashier = () => {
  const auth = useAuth();

  async function close(dados) {
    try {
      const {data} = await http.post('/close', dados, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {close}
}